export default "__VITE_ASSET__BietSJ2x__"